// extracted by mini-css-extract-plugin
export default {"overlay":"LightBox_overlay__6YdPH","btnClose":"LightBox_btnClose__-KPyE"};